/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcBillingV1ChargeEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_BILLING_V1_CHARGE_EVENT_ENTITY_NAME = 'ixc.billing.v1.ChargeEvent';
export const ixcBillingV1ChargeEventEntity = new schema.Entity<IxcBillingV1ChargeEvent>(IXC_BILLING_V1_CHARGE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcBillingV1ChargeEvent) => `${entity.metadata?.eventId}` });

